import { URLS } from '../../config/aws.config';

interface IExecuteAPI {
  token: string;
  username: string;
  jsonData: any;
}

interface IExecuteAPIVerification {
  token: string;
  body: string;
}

const getHeaders = (token: string) => {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
};
export const executeAPIDetermination = async (params: IExecuteAPI) => {
  const { token, username, jsonData } = params;
  const startResponse = await fetch(URLS.execute_api, {
    method: 'POST',
    headers: getHeaders(token),
    body: JSON.stringify({
      inputchoice: 'determination',
      authorization: token,
      username: username,
      body: jsonData, // This removes the base64 prefix (e.g., "data:text/csv;base64,")
      isBase64Encoded: true,
    }),
  });
  return startResponse;
};

export const executeAPIVerification = async (params: IExecuteAPIVerification) => {
  const { token, body } = params;
  const startResponse = await fetch(URLS.execute_api, {
    method: 'POST',
    headers: getHeaders(token),
    body,
  });
  return startResponse;
};

interface IExecuteAPIStatus {
  token: string;
  executionArn: string;
}
export const executeAPIStatus = async (params: IExecuteAPIStatus) => {
  const { token, executionArn } = params;
  const statusResponse = await fetch(URLS.get_status, {
    // Replace with the actual status endpoint
    method: 'POST',
    headers: getHeaders(token),
    body: JSON.stringify({ executionArn }),
  });
  return statusResponse;
};

/*
 *@description: This function is used to update the species data model from s3 bucket
 @param {data: { body: string }}: The body of the request
 @returns {success: boolean, message: string}
 * */
export const updateSpeciesDataModel = async (data: { body: string }) => {
  try {
    const response = await fetch(URLS.update_species_data_model, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    const parsedResponse = await response.json();

    if (parsedResponse.statusCode === 200) {
      if (parsedResponse?.message) {
        return { success: true, message: parsedResponse.message };
      }
    } else {
      return { success: false, message: 'Error updating data' };
    }
  } catch (error) {
    console.log(error);
    return { success: false, message: 'Error updating data' };
  }
};

/*
 *@description: This function is used to get the list of data models from s3 bucket
 @returns {success: boolean, data: any}
 * */
export const getDataModelList = async () => {
  try {
    const res = await fetch(URLS.get_species_data_model);
    const data = await res.json();
    return { success: true, data: data.files };
  } catch (err) {
    console.log('err', err);
    return { success: false, data: null };
  }
};

export const getDataBucketVersions = async (token: string, key: string) => {
  const encodedToken = encodeURIComponent(token);
  const url = `${URLS.get_bucket_data_versions}?key=${encodeURIComponent(key)}&token=${encodedToken}`;
  try {
    const response = await fetch(url);
    const data = await response.json();
    return { success: true, data };
  } catch (err) {
    console.log('err', err);
    return { success: false, data: null };
  }
};

